<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid"
    class="w-100 base-datepicker-with-provider">
    <b-form-group>
      <b-form-input
        :value="value"
        :placeholder="placeholder"
        class="base-datepicker-with-provider__input"
        type="date"
        v-on="$listeners" />
      <BaseErrorMessage
        :color="errorTextColor"
        :errors="errors"
        :class="errorMessageClass" />
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
export default {
  components: {
    BaseErrorMessage,
  },
  props: {
    value: {
      type: [Date, String],
      default: null
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    labelNoDateSelected: {
      type: String,
      default: undefined
    },
    datepickerClass: {
      type: String,
      default: undefined
    },
    dateFormatOptions: {
      type: Object,
      default: undefined
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    right: {
      type: Boolean,
      default: false
    },
    errorTextColor: {
      type: String,
      default: 'primary'
    },
    errors: {
      type: Array,
      default: () => []
    },
    errorMessageClass: {
      type: String,
      default: null
    }
  },
  computed: {
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || null
    }
  }
}
</script>

<style lang="scss">
.base-datepicker-with-provider {

  &__input {
    height: 38px !important;
  }
}
</style>